module.exports = __webpack_public_path__ + "static/media/admin.45676d3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/assets/admin.svg
// module id = 2056
// module chunks = 0